import { useDispatch, useSelector } from 'react-redux'
import { PositionDispatch, RootState } from './types'

export const usePositionDispatch = () => useDispatch<PositionDispatch>()
export const usePositionSelector = useSelector.withTypes<RootState>()
